"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antDesignVue = require("ant-design-vue");
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _default = exports.default = {
  name: 'YsListSort',
  components: {
    AntCheckbox: _antDesignVue.Checkbox,
    AntCheckboxGroup: _antDesignVue.Checkbox.Group,
    Draggable: _vuedraggable.default
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    showOptions: {
      get() {
        return this.value.filter(item => item.show).map(item => item.value);
      },
      set(showOptions) {
        const newValue = this.value.map(item => {
          return {
            ...item,
            show: showOptions.includes(item.value)
          };
        });
        this.$emit('input', newValue);
      }
    },
    sortOptions: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    allCheck() {
      return this.value.every(item => item.show);
    }
  },
  methods: {
    handleChange(e) {
      this.value.forEach(item => item.show = e.target.checked);
    }
  }
};